import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from "rxjs/Observable";

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot) {
        let usuario = JSON.parse(localStorage.getItem('currentUserCobranca'));
        if (usuario) return true;

        // not logged in so redirect to login page
        this.router.navigate(['/login']);
        return false;
    }
}

@Injectable()
export class CanActivateUsuario implements CanActivate {

    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return true;
    }
}

@Injectable()
export class CanActivateClienteBloqueado implements CanActivate {

    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return true;
    }
}


// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/auth/auth.guard.ts